import React, {useEffect, useState} from "react";
import Select from "react-select";
import DataTable from "../../components/tables/DataTable";
import Loader from "../../components/loaders/Loader";
import Pagination from "../../components/Pagination";
import AffiliateNetworkOffersTableFilter from "../../components/AffiliateNetworkOffersTableFilter";
import {
    orderDirectionOptions,
    rowsLimitOptions,
} from "./table-options";
import "./affiliate-network-offers.scss";
import MessageSendingData from "../../components/popups/MessageSendingData";
import CsvDownload from "../../components/buttons/CsvDownload";
import OpenPopupBtn from "../../components/buttons/OpenPopupBtn";
import ClearFilters from "../../components/buttons/ClearFilters";
import TableLoader from "../../components/loaders/TableLoader";
import CustomOpenSelect from "../../components/CustomOpenSelect";
import {useSelector} from "react-redux";
import CSVinVoluumFormatPopup from "../../components/popups/CSVinVoluumFormatPopup";
import prepareCSVData from "../../helpers/prepare-csv-data";
import prepareVoluumFormatCSVData from "../../helpers/prepare-voluum-format-csv-data";
import {UPLOADER_TYPE_OFFERS} from "../../constants";
import CSVinVoluumFormatPopupMultipleSteps from "../../components/popups/CSVinVoluumFormatPopupMultipleSteps";
import BulkLookupFileUploadPopup from "../../components/popups/BulkLookupFileUploadPopup";
import AffisePopup from "../../components/popups/AffisePopup";
import CSVinEmlFormatPopup from "../../components/popups/CSVinEmlFormatPopup";
import YkOffersBulkLookup from "../YieldkitOffersList/YkOffersBulkLookup";
import OffersBulkLookup from "../../components/forms/OffersBulkLookup";
import {AUTH_TOKEN} from "../../constants/Auth";
import {logOut} from "../../redux/dataUploader/dataSlice";
import {useDispatch} from "react-redux";
import ReportsPopup from "../../components/popups/ReportsPopup";
import CSVinBbFormatPopup from "../../components/popups/CSVinBbFormatPopup";

const AffiliateNetworkOffers = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [restOffersData, setRestOffersData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const [rowsLimit, setRowsLimit] = useState({value: "10", label: "10 / page"});
    const [totalRows, setTotalRows] = useState(0);
    const [totalPagesCount, setTotalPagesCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedFilters, setSelectedFilters] = useState({
        orderDirection: orderDirectionOptions[0],
        searchInColumns: {},
    });
    const [orderOptions, setOrderOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState({
        id: localStorage.getItem("id"),
        name: localStorage.getItem("name"),
    })
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
    const [confirmationPopupText, setConfirmationPopupText] = useState("")
    const [usersList, setUsersList] = useState([])
    const [anTypes, setAnTypes] = useState([])
    const [restData, setRestData] = useState(null)
    const [anAccounts, setAnAccounts] = useState([])
    const [selectedANType, setSelectedANType] = useState(null)
    const [selectedANAccount, setSelectedANAccount] = useState(null)
    const [selectedAnUser, setSelectedAnUser] = useState(null);
    const loggedUserEmail = localStorage.getItem("email")

    const [affiseButtonEnabled, setAffiseButtonEnabled] = useState(false);
    const [parsedOffersData, setParsedOffersData] = useState([]);
    const [searchByColumnFields, setSearchByColumnFields] = useState([]);
    const [filterParams, setFilterParams] = useState({
        offer_status: {
            operator: '=',
            value: 'active'
        }
    });

    let [tags, setTags] = useState([
        {
            name: 'offer_status',
            operator: 'Equal',
            value: 'active',
        }
    ]);

    const anAccountStatuses = [
        {label: "Active", value: "active-not-archived"},
        {label: "Archived", value: "active-archived"},
        {label: "Deleted", value: "inactive-archived"}
    ];
    const [anAccountStatus, setAnAccountStatus] = useState([anAccountStatuses[0]]);
    let anAccountStatusRequest = 'status=true&is_archived=false';
    const [anUserId, setAnUserId] = useState(null);
    const userId = localStorage.getItem("id");

    const menuStatus = useSelector(state => state.dataUploader.collapseMenu);
    const isVoluumCSVdifferentColumn = useSelector(state => state.dataUploader.isVoluumCSVdifferentColumn);
    const [csvData, setCsvData] = useState([]);
    const [voluumCsvData, setVoluumCsvData] = useState([]);
    const [popupStatus, setPopupStatus] = useState(false);
    const [bulkLookupPopupStatus, setBulkLookupPopupStatus] = useState(false);
    const [affisePopupStatus, setAffisePopupStatus] = useState(false);
    const [emlPopupStatus, setEmlPopupStatus] = useState(false);
    const [bbPopupStatus, setBbPopupStatus] = useState(false);
    const [urlSearchParams, setUrlSearchParams] = useState("");
    const [selectedCompanyShortName, setSelectedCompanyShortName] = useState('');
    const [reportsPopupStatus, setReportsPopupStatus] = useState(false);

    const localToken = localStorage.getItem(AUTH_TOKEN);
    const selectStyles = {
        container: (baseStyles) => ({
            ...baseStyles,
            maxWidth: "180px",
            width: "100%",
            margin: "0 20px 0 0",
        }),
        control: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
            lineHeight: "1.2",
            minHeight: "26px",
            border: "none",
            borderRadius: "8px",
            "&:hover": {
                cursor: "pointer",
            },
        }),
        placeholder: (baseStyles) => ({
            ...baseStyles,
            fontWeight: 500,
            color: "#1A3353",
        }),
        menu: (baseStyles, state) => ({
            ...baseStyles,
            zIndex: "6",
            "&:hover": {
                cursor: "pointer",
            },
        }),
        option: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
            lineHeight: "1.2",
            "&:hover": {
                cursor: "pointer",
            },
        }),
    }

    const checkSession = (status) => {
        if (status === 401) {
            dispatch(logOut());
        }
    }

    const rowsLimitSelectStyles = {
        control: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
        }),
        option: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
        })
    }

    useEffect(() => {
        if (totalRows > 0) {
            setTotalPagesCount(Math.ceil(totalRows / rowsLimit.value));
        } else {
            setTotalPagesCount(1);
        }
        setCurrentPage(1);
    }, [totalRows, rowsLimit]);

    /* fetch user services */
    useEffect(() => {
        setIsLoading(true);

        // initial fetch
        fetch(`${localStorage.getItem("apiUrl")}api/user/${selectedUser.id}/services?status=true&is_archived=false`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localToken}`
            },
        })
            .then(res => {

                checkSession(res.status);

                if (res.ok) {
                    return res.json()
                }
                return Promise.reject(res)
            })
            .then(res => {
                setSelectedUser({id: res.id, name: res.name})
                setUsersList([...res["user_managers_accounts"]])
                setAnTypes([])

                setAnAccounts([])
                if (res["user_services"] && res["user_services"].length > 0) {
                    let temp = []
                    let types = [] // for unique types
                    res["user_services"].forEach(item => {
                        if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name !== "voluum") {
                            types.push(item?.types?.name)
                            temp.push({value: item?.types?.name, label: item?.types?.name})
                        }
                    })
                    temp.sort((a, b) => a.label.localeCompare(b.label));
                    setAnTypes(temp)
                }

                setRestData(res)
                setIsLoading(false)
            })
            .catch(res => {
                setIsLoading(false)
                setConfirmationPopupText("Something went wrong")
                setShowConfirmationPopup(true)
            })
    }, []);

    /* fetch offer_directions */
    useEffect(() => {
        if (restOffersData.data) {
            setIsLoading(true);

            let urlOrderParam = "";
            if (selectedFilters.orderDirection && selectedFilters.orderBy) {
                urlOrderParam = `&offerSortColumn=${selectedFilters.orderBy.value}&offerSortDirection=${selectedFilters.orderDirection.value}`
            }

            // let urlColumnsToSearchParam = {};
            // if (filterParams) {
            //     urlColumnsToSearchParam = {...filterParams};
            // }

            let allFileters = {};
            if (filterParams) {
                allFileters = {...filterParams};
            }

            const urlColumnsToSearchParam = {
                global_join_by: "AND"
            };

            if (filterParams) {

                Object.keys(allFileters).forEach(key => {
                    const {operator, value} = allFileters[key];

                    urlColumnsToSearchParam[key] = {
                        operator: operator,
                        value: [value],
                        join_by: "AND"
                    };
                });
            }

            let urlParams = `
                ?size=${rowsLimit.value}
                &page=${currentPage}
                ${urlOrderParam}
                &email=${loggedUserEmail}
                &where=${encodeURI(JSON.stringify(urlColumnsToSearchParam))}
            `.replace(/\s{2,}|\n+/gm, ""); //regexp removes more than two whitespaces one by one and linebreaks

            setUrlSearchParams(urlColumnsToSearchParam);

            // fetch offers on filters change
            if (selectedANAccount) {
                fetch(`${localStorage.getItem("apiUrl")}api/affiliate-network/offers/${selectedANAccount.value}/${selectedUser.id}/${urlParams}`, {
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${localToken}`
                    },
                })
                    .then(res => {

                        checkSession(res.status);

                        if (res.ok) {
                            return res.json()
                        }
                        return Promise.reject(res)
                    })
                    .then(res => {
                        setRestOffersData(res.offers)
                        let temp = []

                        searchByColumnFields.forEach(item => {
                            temp.push({value: item.value, label: item.label})
                        })

                        setOrderOptions(temp);
                        setIsLoading(false);
                    })
                    .catch(res => {
                        setIsLoading(false)
                        setConfirmationPopupText("Something went wrong")
                        setShowConfirmationPopup(true)
                    })
            }
        }
        // }, [rowsLimit, currentPage, filterParams, tags]);
    }, [rowsLimit, currentPage, selectedFilters.orderBy, selectedFilters.orderDirection]);


    useEffect(() => {
        if (restOffersData?.data) {
            let temp = [];
            if (restOffersData.data.length !== 0) {
                for (let key in restOffersData.data[0]) {
                    let width = "20%";
                    if (key === "offer_tracking_link") width = "1500px";

                    const renderCell = (item) => {
                        const value = item[key];

                        if (value === true) {
                            return "true";
                        }
                        if (value === false) {
                            return "false";
                        }
                        return (
                            <span
                                key={`${item.offer_id}-${key}`}
                                className={"data-table-cell"}
                                title={"Click to copy"}
                                onClick={() => handleClickToCopy(value)}
                            >
                              {value}
                            </span>
                        );
                    };

                    temp.push({
                        label: key.replaceAll("_", " "),
                        renderCell,
                        resize: true,
                        key: key,
                        id: key, 
                        width: width,
                    });
                }
            }
            if (temp.length > 0) {
                Array.prototype.move = function (from, to) {
                    this.splice(to, 0, this.splice(from, 1)[0]);
                };

                // move Offer Tracking Link column to the end
                let index = temp.findIndex((item) => item.key === "offer_tracking_link");
                temp.move(index, temp.length - 1);

                // move Offer Name column to the second position
                index = temp.findIndex((item) => item.key === "offer_name");
                temp.move(index, 1);
            }
            setColumnDefs(temp);

            setTotalRows(restOffersData["total"]);
            setTotalPagesCount(Math.ceil(totalRows / rowsLimit.value));

        }
    }, [restOffersData]);

    useEffect(() => {
        const user = usersList.find(user =>
            user.user_services.some(service => service.name === selectedANAccount?.label)
        );

        if (user) {
            const network = user.user_services.find(service => service.name === selectedANAccount?.label);
            setSelectedAnUser({user, network});
        } else {
            setSelectedAnUser({user: null, network: null});
        }
    }, [usersList, selectedANAccount]);

    /*  Psrsing offer_country and offer_domain fields  */
    useEffect(() => {
        parsingArrayFields();
    }, [restOffersData.data])

    const buildWhereFromFilters = (filters) => {
        const where = {
            global_join_by: "AND"
        };

        if (!filters) {
            return where;
        }

        Object.keys(filters).forEach(key => {
            const {operator, value} = filters[key];

            where[key] = {
                operator: operator,
                value: [value],
                join_by: "AND"
            };
        });

        return where;
    }

    const getCurrentWhereParams = () => {
        if (filterParams && Object.keys(filterParams).length > 0) {
            return buildWhereFromFilters(filterParams);
        }

        if (urlSearchParams && typeof urlSearchParams === "object") {
            return urlSearchParams;
        }

        return {
            global_join_by: "AND"
        };
    }

    const handleDownloadCsv = () => {
        setIsLoading(true)

        let urlOrderParam = ""
        if (selectedFilters.orderDirection && selectedFilters.orderBy) {
            urlOrderParam = `offerSortColumn=${selectedFilters.orderBy.value}&offerSortDirection=${selectedFilters.orderDirection.value}`
        }

        // let urlColumnsToSearchParam = {};
        // if (filterParams) {
        //     urlColumnsToSearchParam = {...filterParams};
        // }

        let allFileters = {};
        if (filterParams) {
            allFileters = {...filterParams};
        }

        const urlColumnsToSearchParam = {
            global_join_by: "AND"
        };

        if (filterParams) {

            Object.keys(allFileters).forEach(key => {
                const {operator, value} = allFileters[key];

                urlColumnsToSearchParam[key] = {
                    operator: operator,
                    value: [value],
                    join_by: "AND"
                };
            });
        }

        const urlParams = `
            ${urlOrderParam}
            &email=${loggedUserEmail}
            &where=${encodeURI(JSON.stringify(urlColumnsToSearchParam))}
        `.replace(/\s{2,}|\n+/gm, ""); //regexp removes more than two whitespaces one by one and linebreaks


        fetch(`${localStorage.getItem("apiUrl")}api/affiliate-network/download-offers/${selectedANAccount.value}/${selectedUser.id}/?${urlParams}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localToken}`
            },
        })
            .then(res => {

                checkSession(res.status);

                if (res.ok) {
                    return res.json()
                }
                return Promise.reject(res)
            })
            .then(res => {
                setConfirmationPopupText(res.message)
                setShowConfirmationPopup(true)
                setIsLoading(false);
            })
            .catch(res => {
                setIsLoading(false)
                setConfirmationPopupText("Something went wrong")
                setShowConfirmationPopup(true)
            })
    }

    const parsingArrayFields = (offers = restOffersData.data) => {
        const currentOffers = offers;
        const correctOffers = [];
        if (currentOffers && offers.length) {
            setCurrentFilterKeys(offers[0]);

            for (let offer of currentOffers) {
                let correctCountryRow = "";
                let correctDomainRow = "";

                if (offer.offer_country) {
                    let parsedData = JSON.parse(offer.offer_country)
                    for (let country of parsedData) {
                        if (parsedData.length === 1) {
                            correctCountryRow = country
                        } else {
                            correctCountryRow += country + ", "
                        }
                    }
                }

                if (offer.offer_domain) {
                    let parsedData = JSON.parse(offer.offer_domain)
                    for (let domain of parsedData) {
                        if (parsedData.length === 1) {
                            correctDomainRow = domain
                        } else {
                            correctDomainRow += domain + ", "
                        }
                    }
                }

                correctOffers.push(
                    {
                        ...offer,
                        offer_country: correctCountryRow,
                        offer_domain: correctDomainRow,
                        id: offer.offer_id
                    });
                setParsedOffersData(correctOffers);
                setVoluumCsvData(correctOffers);
            }
        }
    }


    const handleChangeSelectedUser = (user) => {
        setIsLoading(true);
        setSelectedANType(null)
        setSelectedANAccount(null)
        setParsedOffersData([])
        setColumnDefs([])
        setAnUserId(user.value);
        setAnAccountStatus([anAccountStatuses[0]]);
        setAffiseButtonEnabled(false);

        let filters = {
            ...selectedFilters,
            searchInColumns: {}
        };

        setSelectedFilters(filters);
        // fetch user services
        fetch(`${localStorage.getItem("apiUrl")}api/user/${user.value}/services?${anAccountStatusRequest}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localToken}`
            },
        })
            .then(res => {

                checkSession(res.status);

                if (res.ok) {
                    return res.json()
                }
                return Promise.reject(res)
            })
            .then(res => {
                setSelectedUser({
                    id: res.id,
                    name: res.name
                })
                setAnTypes([])
                setAnAccounts([])
                setRestOffersData([])
                if (res["user_services"] && res["user_services"].length > 0) {
                    let temp = []
                    let types = [] // for unique types
                    res["user_services"].forEach(item => {
                        if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name !== "voluum") {
                            types.push(item?.types?.name)
                            temp.push({value: item?.types?.name, label: item?.types?.name})
                        }
                    })
                    temp.sort((a, b) => a.label.localeCompare(b.label));
                    setAnTypes(temp)
                }
                setRestData(res)
                setIsLoading(false);
            })
            .catch(res => {
                setIsLoading(false)
                setConfirmationPopupText("Something went wrong")
                setShowConfirmationPopup(true)
            })
    }

    const generateAnAccountStatusRequest = (status) => {
        switch (status.value) {
            case "active-not-archived":
                anAccountStatusRequest = 'status=true&is_archived=false';
                break;
            case "active-archived":
                anAccountStatusRequest = 'status=true&is_archived=true';
                break;
            case "inactive-archived":
                anAccountStatusRequest = 'status=false&is_archived=true';
                break;
            default:
                anAccountStatusRequest = 'status=true&is_archived=false';
        }
    }

    const handleChangeAnAccountStatus = (option) => {

        setSelectedANType(null);
        setSelectedANAccount(null);
        setParsedOffersData([]);

        setAnAccountStatus([option])
        generateAnAccountStatusRequest(option);

        // fetch user services
        if (selectedUser.id) {
            setIsLoading(true);
            fetch(`${localStorage.getItem("apiUrl")}api/user/${selectedUser.id}/services?${anAccountStatusRequest}`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localToken}`
                },
            })
                .then(res => {

                    checkSession(res.status);

                    if (res.ok) {
                        return res.json()
                    }
                    return Promise.reject(res)
                })
                .then(res => {
                    setSelectedUser({
                        id: res.id,
                        name: res.name
                    })
                    setAnTypes([])
                    setAnAccounts([])
                    setRestOffersData([])

                    if (res["user_services"] && res["user_services"].length > 0) {
                        let temp = []
                        let types = [] // for unique types
                        res["user_services"].forEach(item => {
                            if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name !== "voluum") {
                                types.push(item?.types?.name)
                                temp.push({value: item?.types?.name, label: item?.types?.name})
                            }
                        })
                        temp.sort((a, b) => a.label.localeCompare(b.label));
                        setAnTypes(temp);
                    }
                    setRestData(res)
                    setIsLoading(false);
                })
                .catch(res => {
                    setIsLoading(false)
                    setConfirmationPopupText("Something went wrong")
                    setShowConfirmationPopup(true)
                })
        }
    }

    const handleChangeANType = (option) => {
        setSelectedANType(option)
        // setColumnDefs([])
        // setParsedOffersData([])

        let temp = []
        if (restData["user_services"] && restData["user_services"].length > 0) {
            temp = restData["user_services"].filter(item => item?.types?.name === option.value)
            temp = temp.reduce((acc, item) => {
                acc.push({value: item.id, label: item.name})
                return acc
            }, [])
        }
        setAnAccounts(temp)
        setSelectedANAccount(null)
    }

    const handleChangeANAccount = async (option) => {

        setColumnDefs([]);
        setParsedOffersData([]);

        let temp = []
        if (restData["user_services"] && restData["user_services"].length > 0) {
            temp = restData["user_services"].filter(item => item?.name === option.label)
        }

        const accountInfo = temp.find(item => item && (item.id === option.value));
        if (accountInfo.affise_affiliate_id !== null) {
            setAffiseButtonEnabled(true);
        } else {
            setAffiseButtonEnabled(false)
        }

        setSelectedCompanyShortName(temp[0].company_short_name);
        setSelectedANAccount(option);
        setFilterParams({});
        setIsLoading(true);

        let filters = {
            ...selectedFilters,
            searchInColumns: {}
        };

        setSelectedFilters(filters);

        let defaultFilter = {
            offer_status: {
                operator: '=',
                value: 'active'
            }
        };

        const urlColumnsToSearchParam = {
            global_join_by: "AND"
        };

        if (filterParams) {

            Object.keys(defaultFilter).forEach(key => {
                const {operator, value} = defaultFilter[key];

                urlColumnsToSearchParam[key] = {
                    operator: operator,
                    value: [value],
                    join_by: "AND"
                };
            });
        }

        let urlParams = `
            ?size=${rowsLimit.value}
            &page=${currentPage}
            &email=${loggedUserEmail}
            &where=${encodeURI(JSON.stringify(urlColumnsToSearchParam))}
        `.replace(/\s{2,}|\n+/gm, ""); //regexp removes more than two whitespaces one by one and linebreaks

        setUrlSearchParams(urlColumnsToSearchParam);

        const accountID = option.value;
        try {
            const response = await fetch(`${localStorage.getItem("apiUrl")}api/affiliate-network/offers/${accountID}/${selectedUser.id}/${urlParams}`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localToken}`
                },
            });

            checkSession(response.status);

            if (!response.ok) {
                console.error("There are no offers for this account");
                setRestOffersData([]);
                setIsLoading(false);
                return;
            }

            const res = await response.json();

            if (!res || !res.offers || !Array.isArray(res.offers.data)) {
                console.error("Invalid offers data");
                setRestOffersData([]);
                setIsLoading(false);
                return;
            }

            setRestOffersData(res.offers);

            const modifiedData = [...(restOffersData?.data || []), ...(res.offers.data || [])];
            setCsvData(prepareCSVData(modifiedData));
            setVoluumCsvData(modifiedData);
            setFilterParams({
                offer_status: {
                    operator: '=',
                    value: 'active'
                }
            });

            // set default tags
            let tempTag = [];

            tempTag.push({
                name: 'offer_status',
                operator: 'Equal',
                value: 'active',
            });

            setTags(tempTag);

            if (res.offers.data[0]) {
                const filterKeys = Object.keys(res.offers.data[0] || {});
                let filteredKeys = filterKeys.filter(f => f !== "offer_tracking_link");
                let filterValuesArr = [];

                for (let filterKey of filteredKeys) {

                    const fieldLabel = filterKey.replaceAll("_", " ");
                    const fieldType = (filterKey === "created_at"
                        || filterKey === "updated_at"
                        || filterKey === "last_deactivation_date"
                        || filterKey === "last_activation_date") ? "date" : "string";

                    filterValuesArr.push({
                        value: filterKey,
                        label: fieldLabel,
                        type: fieldType,
                    })
                }

                setOrderOptions(filterValuesArr.reduce((acc, item) => {
                    acc.push({value: item.value, label: item.label});
                    return acc;
                }, []));
            }

        } catch (error) {
            console.error(error);
            setIsLoading(false);
            setConfirmationPopupText("Something went wrong");
            setShowConfirmationPopup(true);
        }

        setIsLoading(false);
    };

    const setCurrentFilterKeys = (offer) => {
        const filterKeys = Object.keys(offer);
        let filteredKeys = filterKeys.filter(f => f !== "offer_tracking_link");
        let filterValuesArr = [];

        for (let filterKey of filteredKeys) {

            const fieldLabel = filterKey.replaceAll("_", " ");
            const fieldType = (filterKey === "created_at"
                || filterKey === "updated_at"
                || filterKey === "last_deactivation_date"
                || filterKey === "last_activation_date") ? "date" : "string";

            filterValuesArr.push({
                value: filterKey,
                label: fieldLabel,
                type: fieldType,
            })
        }

        if (filterValuesArr.length > 0) {
            setSearchByColumnFields(filterValuesArr);
        }
    }

    const handleGettingOfferWithSearchParams = async (filters = {}) => {
        setIsLoading(true);

        let urlOrderParam = ""
        if (selectedFilters.orderDirection && selectedFilters.orderBy) {
            urlOrderParam = `offerSortColumn=${selectedFilters.orderBy.value}&offerSortDirection=${selectedFilters.orderDirection.value}`
        }

        let allFileters = {};
        if (filterParams) {
            allFileters = {...filters};
        }

        const urlColumnsToSearchParam = {
            global_join_by: "AND"
        };

        if (filterParams) {

            Object.keys(allFileters).forEach(key => {
                const {operator, value} = allFileters[key];

                urlColumnsToSearchParam[key] = {
                    operator: operator,
                    value: [value],
                    join_by: "AND"
                };
            });
        }

        const urlParams = `
            ${urlOrderParam}
            &email=${loggedUserEmail}
            &where=${encodeURI(JSON.stringify(urlColumnsToSearchParam))}
        `.replace(/\s{2,}|\n+/gm, ""); //regexp removes more than two whitespaces one by one and linebreaks

        setUrlSearchParams(urlColumnsToSearchParam);

        fetch(`${localStorage.getItem("apiUrl")}api/affiliate-network/offers/${selectedANAccount.value}/${selectedUser.id}?${urlParams}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localToken}`
            }
        })
            .then(res => {

                checkSession(res.status);

                if (res.ok) {
                    return res.json()
                }
                return Promise.reject(res)
            })
            .then(res => {
                setRestOffersData(res.offers);
                setTotalRows(res.offers.total);
                setParsedOffersData(res.offers.data);
                parsingArrayFields(res.offers.data);
                setIsLoading(false);
            })
            .catch(e => {
                console.error(e);
                setIsLoading(false);
            })

    }

    const handleChangeSelectedFilters = (value) => {
        setSelectedFilters(value);
    }

    const handleClearSearchByColumnFilter = () => {
        setIsLoading(true);
        let temp = {
            ...selectedFilters,
            searchInColumns: {}
        };


        let urlOrderParam = ""
        if (selectedFilters.orderDirection && selectedFilters.orderBy) {
            urlOrderParam = `offerSortColumn=${selectedFilters.orderBy.value}&offerSortDirection=${selectedFilters.orderDirection.value}`
        }

        const urlColumnsToSearchParam = {
            global_join_by: "AND"
        };

        const urlParams = `
            ${urlOrderParam}
            &email=${loggedUserEmail}
            &where=${encodeURI(JSON.stringify(urlColumnsToSearchParam))}
        `.replace(/\s{2,}|\n+/gm, ""); //regexp removes more than two whitespaces one by one and linebreaks

        setUrlSearchParams(urlColumnsToSearchParam);

        fetch(`${localStorage.getItem("apiUrl")}api/affiliate-network/offers/${selectedANAccount.value}/${selectedUser.id}?${urlParams}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localToken}`
            }
        })
            .then(res => {

                checkSession(res.status);

                if (res.ok) {
                    return res.json()
                }
                return Promise.reject(res)
            })
            .then(res => {
                setRestOffersData(res.offers);
                setTotalRows(res.offers.total);
                setParsedOffersData(res.offers.data);
                parsingArrayFields(res.offers.data);
                setIsLoading(false);
            })
            .catch(e => {
                console.error(e);
                setIsLoading(false);
            })

        setFilterParams({});
        setTags([]);
        setSelectedFilters(temp);
    }

    const handleClickToCopy = (value) => {
        navigator.clipboard.writeText(value).then(() => {
        }, () => {
            console.error('Failed to copy');
        });
    }

    const openVoluumFilePopup = () => {
        setPopupStatus(true);
    }
    const closePopup = () => {
        setPopupStatus(false);
    }

    const openBulkLookupPopup = () => {
        setBulkLookupPopupStatus(true);
    }
    const closeBulkLookupPopup = () => {
        setBulkLookupPopupStatus(false);
    }

    const openAffisePopup = () => {
        setAffisePopupStatus(true);
    }

    const closeAffisePopup = () => {
        setAffisePopupStatus(false);
    }

    const openEmlPopup = () => {
        setEmlPopupStatus(true);
    };

    const closeEmlPopup = () => {
        setEmlPopupStatus(false);
    };

    const openBbPopup = () => {
        setBbPopupStatus(true);
    };

    const closeBbPopup = () => {
        setBbPopupStatus(false);
    };

    const activeCountryFilter = filterParams?.offer_country || urlSearchParams.offer_country || null;
    const activeCountryFilterValue = Array.isArray(activeCountryFilter?.value)
        ? activeCountryFilter.value[0]
        : activeCountryFilter?.value || "";
    const selectedCountryFromFilter = String(activeCountryFilterValue).replaceAll("%", "");
    const selectedCountryOperator = activeCountryFilter?.operator || "";


    if (isLoading) {
        return <div className='loading-wrap'><Loader/></div>
    }

    return (
        <>
            <div className={`affiliate-network-offers-container`}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "0 0 10px",
                }}>


                    <Select
                        className={""}
                        styles={selectStyles}
                        options={usersList
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map(item => ({value: item.id, label: item.name}))}
                        isSearchable={true}
                        defaultValue={{value: selectedUser.id, label: selectedUser.name}}
                        name={"user"}
                        placeholder={"User"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeSelectedUser(option)}
                    />

                    <Select
                        className={""}
                        styles={selectStyles}
                        options={anAccountStatuses}
                        isSearchable={true}
                        defaultValue={{value: anAccountStatus[0].value, label: anAccountStatus[0].label}}
                        name={"account_status"}
                        placeholder={"Account Status"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeAnAccountStatus(option)}
                    />

                    <Select
                        className={""}
                        styles={selectStyles}
                        options={anTypes
                            .slice()
                            .sort((a, b) => a.label.localeCompare(b.label))}
                        isSearchable={true}
                        defaultValue={selectedANType}
                        value={selectedANType}
                        name={"affiliate_network_type"}
                        placeholder={"AN Type"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeANType(option)}
                    />

                    <Select
                        className={""}
                        styles={selectStyles}
                        options={anAccounts
                            .slice()
                            .sort((a, b) => a.label.localeCompare(b.label))}
                        isSearchable={true}
                        defaultValue={selectedANAccount}
                        name={"affiliate_network_account"}
                        placeholder={"AN Account"}
                        value={selectedANAccount}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeANAccount(option)}
                    />
                    
                    {restOffersData.data?.length > 0 &&
                        <div className={"csv-btn-container"}>

                            <button
                                className="blue-btn"
                                onClick={() => setReportsPopupStatus(true)}
                            >
                                Open Reports
                            </button>

                            {/* TODO: after click on "clear all filters" there is infinite loading */}
                            {/*<ClearFilters clearFilters={clearFilters} disabled={isLoadingRestData}/>*/}
                        </div>
                    }

                    {reportsPopupStatus && (
                        <ReportsPopup
                            closePopup={() => setReportsPopupStatus(false)}

                            handleDownloadCsv={() => {
                                handleDownloadCsv();
                                setReportsPopupStatus(false);
                            }}

                            openVoluumFilePopup={() => {
                                openVoluumFilePopup();
                                setReportsPopupStatus(false);
                            }}

                            openBulkLookupPopup={() => {
                                openBulkLookupPopup();
                                setReportsPopupStatus(false);
                            }}

                            openAffisePopup={() => {
                                openAffisePopup();
                                setReportsPopupStatus(false);
                            }}

                            openEmlPopup={() => {
                                openEmlPopup();
                                setReportsPopupStatus(false);
                            }}

                            openBbPopup={() => {
                                openBbPopup();
                                setReportsPopupStatus(false);
                            }}

                            isDataAvailable={Boolean(restOffersData["data"])}
                            affiseButtonEnabled={affiseButtonEnabled}
                            selectedANType={selectedANType?.value}
                        />
                    )}

                    {popupStatus ?
                        <CSVinVoluumFormatPopupMultipleSteps
                            csvData={voluumCsvData}
                            closePopup={closePopup}
                            from='affiliate'
                            anAccount={selectedANAccount.value}
                            userId={selectedUser.id}
                            selectedCountryFromFilter={selectedCountryFromFilter}
                            selectedCountryOperator={selectedCountryOperator}
                            urlSearchParams={urlSearchParams}
                            filterParams={filterParams}
                            account={selectedAnUser}
                        /> : null
                    }

                    {bulkLookupPopupStatus ?
                        <BulkLookupFileUploadPopup
                            csvData={voluumCsvData}
                            closePopup={closeBulkLookupPopup}
                            from='affiliate'
                            anAccount={selectedANAccount.value}
                            anAccountLabel={selectedANAccount.label}
                            selectedCompanyShortName={selectedCompanyShortName}
                            userId={selectedUser.id}
                            selectedCountryFromFilter={selectedCountryFromFilter}
                            selectedCountryOperator={selectedCountryOperator}
                            urlSearchParams={urlSearchParams}

                            restOffersData={restOffersData.data}
                            columns={columnDefs?.key}
                            account={selectedAnUser}
                        /> : null
                    }

                    {affisePopupStatus ?
                        <AffisePopup
                            closeAffisePopup={closeAffisePopup}
                            selectStyles={selectStyles}
                            filterParams={filterParams}
                            userId={selectedUser.id}
                            selectedANAccount={selectedANAccount.value}
                            offerSortColumn={selectedFilters.orderBy?.value || 'offer_name'}
                            offerSortDirection={selectedFilters.orderDirection.value || null}
                            setShowConfirmationPopup={setShowConfirmationPopup}
                            setConfirmationPopupText={setConfirmationPopupText}
                            totalRows={totalRows}
                            from='affiliate'
                            filename="affise_format_affiliate_network_offers_list"
                        /> : null
                    }

                    {emlPopupStatus && (
                        <CSVinEmlFormatPopup
                            csvData={voluumCsvData}
                            closePopup={closeEmlPopup}
                            from="affiliate"
                            anAccount={selectedANAccount.value}
                            userId={selectedUser.id}
                            selectedCountryFromFilter={selectedCountryFromFilter}
                            selectedCountryOperator={selectedCountryOperator}
                            urlSearchParams={urlSearchParams}
                            filterParams={filterParams}
                            account={selectedAnUser}
                        />
                    )}

                    {bbPopupStatus && (
                        <CSVinBbFormatPopup
                            closePopup={closeBbPopup}
                            serviceId={selectedANAccount.value}
                            userId={selectedUser.id}
                            urlSearchParams={urlSearchParams}
                            filterParams={filterParams}
                            where={JSON.stringify(getCurrentWhereParams())}
                            offerSortColumn={selectedFilters.orderBy?.value || "created_at"}
                            offerSortDirection={selectedFilters.orderBy
                                ? selectedFilters.orderDirection?.value || "desc"
                                : "desc"}
                        />
                    )}

                </div>

                {/* {restOffersData.data && <OffersBulkLookup columns={columnDefs?.key} account={selectedAnUser} />} */}

                <>
                    <AffiliateNetworkOffersTableFilter
                        orderByOptions={orderOptions}
                        orderDirectionOptions={orderDirectionOptions}
                        searchByColumnOptions={searchByColumnFields}
                        selectedFilters={selectedFilters}
                        handleGettingOfferWithSearchParams={handleGettingOfferWithSearchParams}
                        changeSelectedFilters={handleChangeSelectedFilters}
                        clearSearchFilters={handleClearSearchByColumnFilter}
                        setFilterParams={setFilterParams}
                        filterParams={filterParams}
                        setTags={setTags}
                        tags={tags}
                        selectedANAccount={selectedANAccount}
                        selectedANType={selectedANType}
                    />

                    <DataTable
                        key={selectedANAccount?.value}
                        data={parsedOffersData}
                        columnDefs={columnDefs}
                        selectedANAccount={selectedANAccount}
                    />
                </>

                {restOffersData.data && (
                    <div className="data-table-footer">
                        {rowsLimitOptions.length > 0 && (
                            //TODO: винести в окремий компонент
                            <Select
                                className={"data-table-rows-limit"}
                                styles={rowsLimitSelectStyles}
                                options={rowsLimitOptions}
                                isSearchable={false}
                                defaultValue={rowsLimit}
                                name={"rows_count"}
                                onChange={(option) => {
                                    setRowsLimit(option);
                                    setCurrentPage(1);
                                }}
                            />
                        )}
                        <div className={"data-table-rows-count"}>Total rows: <strong>{totalRows}</strong></div>
                        <Pagination
                            totalPagesCount={totalPagesCount}
                            setCurrentPage={(value) => setCurrentPage(value)}
                            currentPage={currentPage}
                        />
                    </div>
                )}
            </div>

            {showConfirmationPopup && (
                <MessageSendingData
                    messageText={confirmationPopupText}
                    setClosePopup={() => setShowConfirmationPopup(false)}
                />
            )}
        </>
    )
}

export default AffiliateNetworkOffers;
